import { apiGet } from "./client";

export async function fetchMasterData() {
  return apiGet("/master-data");
}
